import { BaseServiceOutput, ErrorCode } from './base';

export enum UserAliasTypeEnum {
	Unknown = 0,
	Individuals = 1,
	Corporate = 8,
	CorporateAB = 9,
}

export enum ChallengeTypeEnum {
	None = 0,
	Password = 1,
	Nif = 2,
	Multichannel = 5,
	MultichannelCompanyOperatorCoHolder = 31,
}

export enum SafeCredentialTypeEnum {
	Sms = 5,
	Token = 6,
	SmsOrToken = 8,
}

export interface AccountLoginInputDto {
	fingerprint?: string | null;
	cookieCifra?: string | null;
	userAlias?: string | null;
	returnUrl?: string | null;
	bank?: number | null;
	language?: string | null;
}

export interface AccountLoginOutputDto {
	challengeType?: ChallengeTypeEnum | null;
	userAlias?: string | null;
	userAliasTypeId?: UserAliasTypeEnum | null;
	returnUrl?: string | null;
	needsTaxNumber?: boolean | null;
	needsSafe?: boolean | null;
	safeCredentialType?: SafeCredentialTypeEnum | null;
	positionsToAsk?: number[] | null;
	sdcSessionId?: string | null;
	sdcBusinessSessionId?: string | null;
	bank?: number | null;
	needsCertificate?: boolean | null;
	wrongContext?: boolean | null;
	geo?: string | null;
	targetSystem?: string | null;
	targetInfrastructure?: string | null;
	errorMessage?: string | null;
	errorCode?: ErrorCode | string | null;
	oldSite?: boolean | null;
}

export type AccountLoginOutputDtoSingleOutputMessage = BaseServiceOutput<AccountLoginInputDto, AccountLoginOutputDto>;
